import { all } from 'redux-saga/effects';

import allSaga from './all/saga';
import appliedSaga from './applied/saga';
import categoriesSaga from './categories/saga';
import categorizedSaga from './categorized/saga';
import detailsSaga from './details/saga';
import favouriteSaga from './favourite/saga';
import reserveSaga from './reserve/saga';
import applySaga from './apply/saga';
import followedCouponsSaga from './followedCoupons/saga';

export default function* saga() {
  yield all([
    allSaga(),
    appliedSaga(),
    categoriesSaga(),
    categorizedSaga(),
    detailsSaga(),
    favouriteSaga(),
    reserveSaga(),
    applySaga(),
    followedCouponsSaga(),
  ]);
}
